export default {
  linkAccount: '绑定账号',
  inputPhone: '输入手机号',
  bindLogin: '绑定登录',
  loginAction: '登录',
  registerAction: '注册',
  registerNow: '立即注册',
  contactInput: '输入手机号或邮箱',
  verificationCodeInput: '输入验证码',
  loginRegister: '登 录 / 注 册',
  agreementCheck1: '我已阅读并同意',
  agreementCheck2: '第三方商品平台交易服务协议',
  getCode: '获取验证码',
  codeInputPrompt: '请输入你的验证码',
  agreementPrompt: '请阅读并勾选服务协议',
  validContactPrompt: '请输入正确的手机号或邮箱',
  retryCountdown: '秒后获取',
  frequentContactInput: '输入常用手机号或邮箱',
  passwordInput: '输入密码',
  passwordPrompt: '请输入密码',
  expiredRefresh: '已失效,点击刷新',
  qrScanPrompt: '扫码关注',
  instantAccess: '即可登录注册',
  autoRegistration: '首次扫码将自动注册新账号',
  forgotPassword: '忘记密码',
  newPasswordInput: '输入新登录密码',
  resetPasswordAction: '重置密码',
  accountNotRegistered: '该手机号或邮箱未注册',
  invalidParameters: '参数不合法',
  wechatLogin: '微信扫码登录或注册',
  smsLogin: '手机/邮箱验证码登录',
  passwordLogin: '密码登录',
  accountLoginOption: '账号登录在这里',
  qrLoginOption: '扫码登录在这里'
}
